import { Text } from '@factorialco/deprecated-design-system'
import { ProcurementValueObjectsPurchaseRequestStatusEnum } from 'generated/resources/graphql'
import moment from 'moment'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'

interface Props {
  status: ProcurementValueObjectsPurchaseRequestStatusEnum
  deadline: string | null | undefined
}

export const PurchaseRequestDeadline = ({ status, deadline }: Props) => {
  const isDeadlineSoon = () => {
    if (!deadline) {
      return false
    }

    return moment(deadline) <= moment().add(3, 'days')
  }

  const color = () => {
    if (status != 'pending') {
      return 'grey800'
    }

    return isDeadlineSoon() ? 'radicalRed1200' : 'grey800'
  }

  return (
    <Text.Normal size="200" color={color()}>
      {deadline ? dateBackendDateTimeToUI(deadline) : '-'}
    </Text.Normal>
  )
}
